function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import cs from "classnames";
import styles from "./style/index.module.less";
const COLORS = ["#f44336", "#e91e63", "#9c27b0", "#673ab7", "#3f51b5", "#2196f3", "#03a9f4", "#00bcd4", "#009688", "#4caf50", "#8bc34a", "#cddc39", "#ffeb3b", "#ffc107", "#ff9800", "#ff5722"];

function hashString(str) {
  let hash = 0;

  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }

  return hash;
}

function getColor(text, color) {
  if (color) {
    return color;
  }

  if (!text) {
    return COLORS[0];
  }

  const hash = hashString(text.toLowerCase());
  return COLORS[Math.abs(hash) % COLORS.length];
}

function CircleAvatar(props) {
  const {
    text = "U",
    size = 40,
    color,
    className,
    style,
    children,
    ...rest
  } = props;
  const trimmed = text.trim();
  const displayChar = trimmed ? trimmed.charAt(0).toUpperCase() : "U";
  const dimension = typeof size === "number" ? size : parseFloat(String(size));
  const fontSize = Math.floor(dimension * 0.4);
  const mergedStyle = {
    width: dimension,
    height: dimension,
    fontSize,
    backgroundColor: getColor(trimmed, color),
    ...style
  };
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cs(styles.avatar, className),
    style: mergedStyle
  }, rest), children || displayChar);
}

export default CircleAvatar;